import {MdPhoto} from "react-icons/md";
import {useNavigate} from "react-router-dom";
import Platforms from "../../tools/defaults/Platforms";

const EmptyImage=()=>{
    return <div className="image-wrapper">
        <MdPhoto className="text-gray-500 text-3xl"/>
    </div>
}

const PostCard=(props)=>{
    const {post,serviceType,defaultData}=props;
    const navigate=useNavigate();
    const discountCode=localStorage.getItem('discount_code');

    const handleLink=(serviceType,post_token)=>{

        navigate(`/auth/gate/${Platforms.DIVAR.ID}/${serviceType}?post_token=${post_token}${discountCode ? '&discount_code='+discountCode :''}`,{
            replace:true,
        })
    }
    return <div className="post-card">
            <div className="flex w-full   justify-start  items-end">
                {post?.images && post?.images.length>0 ? <div className="image-wrapper"><img src={post?.images[0]}  alt="" className="w-full rounded-lg"/></div> : <EmptyImage/>}
                <div className="w-full  pr-4">
                    <span className="mb-1 font-bold">{post?.title}</span>

                    <div className="w-full flex mt-3 pt-3  justify-end">
                        <button onClick={()=>handleLink(serviceType,post?.token)}  >{defaultData.button}</button>
                    </div>
                </div>
            </div>

           </div>
}
export default PostCard;